import Borders from '@dynatrace/strato-design-tokens/borders';
import Colors from '@dynatrace/strato-design-tokens/colors';
import Spacings from '@dynatrace/strato-design-tokens/spacings';

import { dtVisualRefreshEnabled } from '../../core/components/app-root/AppRoot.sty.js';

// Base structural overrides — used by both inline and overlay resize containers.
export const vrResizeHandleContainerBaseOverrides = {
  borderRadius: 0,
  height: '100%',
  width: Spacings.Size8,
  left: 0,
  transition: 'none',
};

// Styles for the ::before pseudo-element that draws the 1px visual divider line.
export const vrResizeHandleContainerBeforeOverrides = {
  content: '""',
  position: 'absolute' as const,
  top: 0,
  bottom: 0,
  left: '50%',
  transform: 'translateX(-50%)',
  width: Borders.Width.Default,
  backgroundColor: Colors.Border.Neutral.Subdued,
  pointerEvents: 'none' as const,
};

// Hover/active color changes applied to the ::before line.
export const vrResizeHandleContainerInteractionOverrides = {
  [`.${dtVisualRefreshEnabled} &:hover::before`]: {
    backgroundColor: Colors.Border.Neutral.SubduedHover,
  },
  [`.${dtVisualRefreshEnabled} &:active::before`]: {
    backgroundColor: Colors.Border.Neutral.SubduedActive,
  },
};

// Complete overrides for INLINE resize containers (between flex siblings in SplitLayout / Panel).
// Negative marginInline collapses the container to 0px of flex space so adjacent panels connect
// seamlessly. The container still renders 8px wide (4px each side of the boundary) for interaction.
// z-index: 1 ensures the container sits above both neighbouring panels.
export const vrResizeHandleContainerOverrides = {
  [`.${dtVisualRefreshEnabled} &`]: {
    ...vrResizeHandleContainerBaseOverrides,
    backgroundColor: 'transparent',
    marginInline: `calc(${Spacings.Size8} / -2)`,
    zIndex: 1,
  },
  [`.${dtVisualRefreshEnabled} &::before`]:
    vrResizeHandleContainerBeforeOverrides,
  ...vrResizeHandleContainerInteractionOverrides,
};

export const vrResizeHandleOverrides = {
  [`.${dtVisualRefreshEnabled} &`]: {
    width: 0,
    cursor: 'ew-resize',
  },
};

// Applied to the ::before pseudo-element when the resize handle has keyboard focus.
export const vrResizeHandleFocusOverrides = {
  backgroundColor: Colors.Border.Neutral.Accent,
  width: Borders.Width.Emphasized,
};
